import Avatar from 'components/Avatar'
import ChatState from './ChatState'

import {
  Chat,
  Container,
  Meta,
  Username
} from './styles'

export default function ChatSystem() {

  if (!ChatState.isOpen) {
    return <></>
  }

  return (
    <Chat>

      <Container>
        
        <Meta>
          <Avatar src='https://theprime.gg/favicon.ico' size='chat' />
          <Username>Butterbean</Username>
        </Meta>

      </Container>

    </Chat>
  )
}